import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { GoogleMap, useJsApiLoader, MarkerF } from "@react-google-maps/api";
import { Spin } from "antd";
import { withTheme } from "styled-components";
const libraries = ["places"];

const Map = (props) => {
  const { marker, type } = props;
  const [viewport, setViewport] = useState({
    zoom: 16,
    height: type === "mini" ? 300 : window.innerHeight * 0.9,
  });

  const { isLoaded, loadError } = useJsApiLoader({
    googleMapsApiKey: "AIzaSyDs2QkqANgCTQIcThQFCiNkxcKGPVkS_lM",
    libraries: libraries,
    id: "google-map-script",
    language: "he",
  });

  useEffect(() => {
    if (marker) {
      setViewport({
        ...viewport,
        center: {
          lat: marker.latitude,
          lng: marker.longitude,
        },
        lat: marker.latitude,
        lng: marker.longitude,
        zoom: 16,
      });
    }
  }, [marker]);

  const containerStyle = {
    height: viewport.height,
    width: "100%",
  };

  const handleApiLoaded = (map, maps) => {
    if (marker) {
      setViewport({
        ...viewport,
        center: {
          lat: marker.latitude,
          lng: marker.longitude,
        },
        lat: marker.latitude,
        lng: marker.longitude,
        zoom: 16,
      });
    }
  };

  const renderMap = () => {
    return (
      <GoogleMap
        mapContainerStyle={containerStyle}
        center={viewport.center}
        zoom={viewport.zoom}
        clickableIcons={false}
        onLoad={handleApiLoaded}
        options={{ gestureHandling: "cooperative" }}
      >
        <>
          {marker && (
            <MarkerF position={{ lat: viewport.lat, lng: viewport.lng }} />
          )}
        </>
      </GoogleMap>
    );
  };

  if (loadError) {
    return <div>Map cannot be loaded right now, sorry.</div>;
  }

  return isLoaded ? renderMap() : <Spin size="large" />;
};

Map.propTypes = {
  marker: PropTypes.object,
  type: PropTypes.string,
};
export default withTheme(Map);
